import React from "react";

import "./Weather.css";

export default function WeatherData(props) {
  return (
    <span>
      <span class="row weather-data current-weather-icon">
        <img
          src={props.showIcon}
          alt={props.showDescription}
          class="current-icon"
        />
      </span>
      <span class="row weather-data current-weather-description ">
        {props.showDescription}
      </span>
      <span class="row weather-data ">
        <h1>{props.showCity}</h1>
      </span>
    </span>
  );
}
